import React from 'react'
import EditIcon from 'assets/icons/edit-icon'
import RemoveIcon from 'assets/icons/remove-icon16px'
import EyeIcon from 'assets/icons/eye-2-line-icon'
import NominateIcon from 'assets/icons/nominate-icon'
import ViewIcon from 'assets/icons/view-icon'
import ReassessIcon from 'assets/icons/reassess-icon'
import {
  SITE_STATUS_CONFIRMED_ID,
  SITE_STATUS_DELISTED_ID,
  SITE_STATUS_DOES_NOT_QUALIFY,
  SITE_STATUS_DRAFT_ID,
  SITE_STATUS_EDIT_ONLY_ID,
  SITE_STATUS_NOT_ASSESSED_ID,
  SITE_STATUS_REVIEWED_BY_RFP_ID,
} from '../siteStatuses'
import { getEditOnlyContext } from '../../utils/editOnlyContext'
import { canViewSiteInMySites } from '../../utils/rolePermissions'
import {
  createNavigateIndividualConfirmedView,
  createNavigateIndividualDefaultViewSite,
  createNavigateIndividualReviewedByRfp,
  createNavigateReviewDetails,
} from '../../utils/navigationHandlers'

function buildDraftOrEditOnlyItems(site, history, setSiteForDeleting, setEditOnlySiteToReject) {
  const { editOnlySite, editOnlySiteStatus } = getEditOnlyContext(site)
  return [
    {
      icon: <EditIcon />,
      title: 'edit',
      onClick: createNavigateReviewDetails(site, history, editOnlySite, editOnlySiteStatus),
    },
    {
      icon: <RemoveIcon />,
      title: 'Remove',
      onClick: () => {
        if (editOnlySiteStatus) {
          setEditOnlySiteToReject({ ...site, isApproved: false, delete: true })
          return
        }
        setSiteForDeleting(site)
      },
    },
  ]
}

function buildReviewedByRfpItems(site, history, setSiteToWorkWith) {
  const { editOnlySite, editOnlySiteStatus } = getEditOnlyContext(site)
  return [
    {
      icon: <EyeIcon />,
      title: 'review',
      onClick: createNavigateIndividualReviewedByRfp(site, history, editOnlySite, editOnlySiteStatus),
    },
    {
      icon: <NominateIcon />,
      title: 'nominateSite',
      onClick: () => {
        setSiteToWorkWith(site)
      },
    },
  ]
}

function buildConfirmedDelistedDnqItems(site, history, toggleModal, setSite, setSiteIsModalEditOpen) {
  const { editOnlySite } = getEditOnlyContext(site)
  return [
    {
      icon: <ViewIcon />,
      title: 'viewSite',
      onClick: createNavigateIndividualConfirmedView(site, history, editOnlySite),
    },
    {
      icon: <ReassessIcon />,
      title: 'reassessSite',
      disabled: false,
      onClick: () => {
        toggleModal()
        setSite({
          id: site.id,
        })
      },
    },
    {
      icon: <EditIcon />,
      title: 'editNow',
      disabled: false,
      onClick: () => {
        setSiteIsModalEditOpen(site)
      },
    },
  ]
}

function buildNotAssessedItems(site, toggleModal, setSite) {
  return [
    {
      icon: <ReassessIcon />,
      title: 'reassessSite',
      disabled: false,
      onClick: () => {
        toggleModal()
        setSite({
          id: site.id,
        })
      },
    },
  ]
}

function buildIndividualDefaultItems(site, history) {
  const { editOnlySite, editOnlySiteStatus } = getEditOnlyContext(site)
  return [
    {
      icon: <ViewIcon />,
      title: 'viewSite',
      onClick: createNavigateIndividualDefaultViewSite(site, history, editOnlySite, editOnlySiteStatus),
    },
  ]
}

export function buildIndividualMenuItems(ctx) {
  const {
    site,
    profile,
    isMySite,
    history,
    setSiteToWorkWith,
    setSiteForDeleting,
    toggleModal,
    setSite,
    setSiteIsModalEditOpen,
    setEditOnlySiteToReject,
  } = ctx

  if ([SITE_STATUS_DRAFT_ID, SITE_STATUS_EDIT_ONLY_ID].includes(site.SiteStatus.id)) {
    if (!canViewSiteInMySites(site, profile)) {
      if (isMySite) {
        return []
      }
      return buildIndividualDefaultItems(site, history)
    }
    return buildDraftOrEditOnlyItems(site, history, setSiteForDeleting, setEditOnlySiteToReject)
  }
  if (site?.SiteStatus?.id === SITE_STATUS_REVIEWED_BY_RFP_ID) {
    return buildReviewedByRfpItems(site, history, setSiteToWorkWith)
  }
  if (
    site?.SiteStatus &&
    (site.SiteStatus.id === SITE_STATUS_CONFIRMED_ID ||
      site.SiteStatus.id === SITE_STATUS_DELISTED_ID ||
      site.SiteStatus.id === SITE_STATUS_DOES_NOT_QUALIFY)
  ) {
    return buildConfirmedDelistedDnqItems(site, history, toggleModal, setSite, setSiteIsModalEditOpen)
  }
  if (site?.SiteStatus?.id === SITE_STATUS_NOT_ASSESSED_ID) {
    return buildNotAssessedItems(site, toggleModal, setSite)
  }
  return buildIndividualDefaultItems(site, history)
}

export function parseIndividualMenuArgs(args) {
  const [
    site,
    profile,
    isMySite = false,
    history,
    setSiteToWorkWith,
    setSiteForDeleting,
    toggleModal,
    setSite,
    setSiteIsModalEditOpen,
    setEditOnlySiteToReject,
  ] = args

  return {
    site,
    profile,
    isMySite,
    history,
    setSiteToWorkWith,
    setSiteForDeleting,
    toggleModal,
    setSite,
    setSiteIsModalEditOpen,
    setEditOnlySiteToReject,
  }
}

export function getIndividualActionMenuItems(...args) {
  return buildIndividualMenuItems(parseIndividualMenuArgs(args))
}
